import loadable from '@loadable/component';

export const OrgDashboardOrgSubLayoutLoadable = loadable(
  () => import('./OrgDashboardOrgSubLayout'),
  { resolveComponent: (module) => module.OrgDashboardOrgSubLayout },
);
